// Gestion des description des coachs

function truncateText(text, maxLength) {
  truncated = text.innerHTML;

  if (truncated.length > maxLength) {
    truncated = truncated.substr(0,maxLength)
  }
  return truncated;
}

const temoignages = document.querySelectorAll(".coach-biography-container")

for (var i = 0, len = temoignages.length; i < len; i++) {

  const originalText = temoignages[i].querySelector(".coach-biography")
  const readLess = "<a class='read-less-coachs'>"  + "réduire -" + "</a>"
  originalText.insertAdjacentHTML('beforeend', readLess )
  temoignages[i].querySelector(".coach-biography").classList.add('hide')

  const newP = document.createElement('p');
  newP.innerHTML = truncateText(originalText, 300) + "..." + "<br>" + "<a class='read-more-coachs'>"  + "en savoir plus +" + "</a>"
  temoignages[i].appendChild(newP).classList.add('coachs-description')

  temoignages[i].querySelector(".read-more-coachs").addEventListener('click', function(e) {
    newP.classList.add('hide')
    originalText.classList.remove('hide')
  })

  temoignages[i].querySelector(".read-less-coachs").addEventListener('click', function(e) {
    newP.classList.remove('hide')
    originalText.classList.add('hide')
  })

}
